import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import PageHero from '../components/layout/PageHero';
import SEO from '../components/SEO';
import content from '../data/health_infrastructure_content.json';
import RichTextRenderer from '../components/content/RichTextRenderer';
import './HealthInfrastructure.css';

export default function HealthInfrastructure() {

    const renderSection = (section, index) => {
        const infraLabel = `INFRA-${(index + 1).toString().padStart(2, '0')}`;

        switch (section.type) {
            case 'intro-block':
                return (
                    <div key={section.id} className="hi-section intro-section" data-infra-label={infraLabel}>
                        <RichTextRenderer content={section.text} className="intro-text" />
                    </div>
                );

            case 'text-list':
                return (
                    <div key={section.id} className="hi-section text-list-section" data-infra-label={infraLabel}>
                        {section.subtitle && <span className="section-subtitle">{section.subtitle}</span>}
                        <h2>{section.title}</h2>
                        <div className="text-content">
                            <RichTextRenderer content={section.intro} className="section-intro" />
                            <ul className="accent-list">
                                {section.list.map((li, i) => (
                                    <li key={i}>
                                        <Check size={20} className="check-icon" />
                                        <div className="li-content">
                                            <RichTextRenderer content={li} />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                );

            case 'text-block':
                return (
                    <div key={section.id} className={`hi-section text-block-section ${section.image ? 'has-image' : ''}`} data-infra-label={infraLabel}>
                        <h2>{section.title}</h2>
                        {section.subtitle && <span className="section-subtitle">{section.subtitle}</span>}
                        <div className="block-content">
                            {section.image && (
                                <div className="section-image-wrapper">
                                    <img src={section.image} alt={section.title} className="section-img" />
                                </div>
                            )}
                            <RichTextRenderer content={section.content} />
                        </div>
                    </div>
                );

            case 'highlight-block':
                return (
                    <div key={section.id} className={`hi-section highlight-section ${section.image ? 'has-image' : ''}`} data-infra-label={infraLabel}>
                        <div className="big-quote">
                            {section.image && (
                                <div className="section-image-wrapper highlight-image">
                                    <img src={section.image} alt={section.title} className="section-img" />
                                </div>
                            )}
                            <RichTextRenderer content={section.text} />
                        </div>
                    </div>
                );

            case 'impact-statement':
                return (
                    <div key={section.id} className="hi-section impact-section" data-infra-label="PROCLAMATION">
                        <div className="impact-statement">
                            <RichTextRenderer content={section.text} />
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="hi-page">
            <SEO
                title="The Infrastructure of Health - SAFEC+"
                description="Why SAFECare+ is the pragmatic reset America needs. Treating healthcare as critical infrastructure."
                image={content.hero_image}
            />
            <PageHero
                title={content.title}
                subtitle={content.subtitle}
                image={content.hero_image}
                badge="The Construction Plan"
            />

            <div className="hi-content-container">
                {content.sections.map((section, index) => (
                    <motion.div
                        key={section.id}
                        initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
                    >
                        {renderSection(section, index)}
                    </motion.div>
                ))}
            </div>
        </div>
    );
}
